import showdown from 'showdown';

import TurndownService from 'turndown';
const turndownService = new TurndownService({ hr: '---' });

const markupConverter = new showdown.Converter();

turndownService
  .addRule('h1', {
    filter: ['h1'],
    replacement: function (content: string) {
      return '\n# ' + content;
    },
  })
  .addRule('h2', {
    filter: ['h2'],
    replacement: function (content: string) {
      return '\n## ' + content;
    },
  })
  .addRule('h3', {
    filter: ['h3'],
    replacement: function (content: string) {
      return '\n### ' + content;
    },
  });

export function markdownToHtml(markdown: string) {
  const markdownAsHtml = markupConverter.makeHtml(markdown);
  // Replace @@CONTETN@@ with <center>CONTENT</center>

  const contentRegex = /@@(.+?)@@/gim;
  const foundContent = [...markdownAsHtml.matchAll(contentRegex)];

  let newMarkdownAsHtml = markdownAsHtml;

  for (const found of foundContent) {
    if (found.length > 0) {
      const contentStr = found[0];
      const newContentStr = `<center>${found[1]}</center>`;
      newMarkdownAsHtml = newMarkdownAsHtml.replace(contentStr, newContentStr);
    }
  }

  return newMarkdownAsHtml;
}

export function htmlToMarkdown(html: string) {
  let newMarkdown = html;

  // Replace <center>CONTENT</center> with @@CONTENT@@

  const contentRegex = /<center>(.+?)<\/center>/gim;
  const foundContent = [...newMarkdown.matchAll(contentRegex)];

  for (const found of foundContent) {
    if (found.length > 0) {
      const contentStr = found[0];
      const newContentStr = `@@${found[1]}@@`;
      newMarkdown = newMarkdown.replace(contentStr, newContentStr);
    }
  }

  newMarkdown = turndownService.turndown(newMarkdown);

  return newMarkdown;
}
